(() => {
  'use strict';

  function applySavedComposition(preview) {
    if (preview.dataset.previewReady === 'true') return;
    preview.dataset.previewReady = 'true';
    const wordBox = preview.querySelector('[data-preview-word]');
    if (!wordBox) return;

    let composition;
    try {
      composition = JSON.parse(preview.dataset.composition || '{}');
    } catch (_) {
      composition = {};
    }
    const lines = Array.isArray(composition.lines)
      ? composition.lines.filter((line) => typeof line === 'string' && line.trim()).slice(0, 3)
      : [];
    if (!lines.length) return;

    wordBox.replaceChildren();
    lines.forEach((line, index) => {
      const span = document.createElement('span');
      span.textContent = line;
      if (index === lines.length - 1) {
        const dot = document.createElement('i');
        dot.className = 'lpa-cart-poster-preview__dot';
        dot.setAttribute('aria-hidden', 'true');
        span.appendChild(dot);
      }
      wordBox.appendChild(span);
    });

    const layout = composition.layout || {};
    const scale = Number(layout.scale);
    const top = Number(layout.top);
    const definition = Number(layout.definition);
    const lineHeight = Number(layout.lineHeight);
    const dotGap = layout.dotGap === null || layout.dotGap === undefined ? NaN : Number(layout.dotGap);
    if (Number.isFinite(scale) && scale >= .35 && scale <= 4) preview.style.setProperty('--word-scale', String(scale));
    if (Number.isFinite(top) && top >= 0 && top <= 75) preview.style.setProperty('--word-top', `${top}%`);
    if (Number.isFinite(definition) && definition >= 15 && definition <= 90) preview.style.setProperty('--definition-top', `${definition}%`);
    if (Number.isFinite(lineHeight) && lineHeight >= .5 && lineHeight <= 1.5) preview.style.setProperty('--word-line-height', String(lineHeight));
    if (Number.isFinite(dotGap) && dotGap >= -12 && dotGap <= 12) preview.style.setProperty('--dot-gap', `${dotGap}cqw`);
  }

  function initialize(root = document) {
    root.querySelectorAll('.lpa-cart-poster-preview:not([data-preview-ready])').forEach(applySavedComposition);
  }

  initialize();
  if (!window.lpaCartPosterPreviewObserver) {
    window.lpaCartPosterPreviewObserver = new MutationObserver(() => initialize());
    window.lpaCartPosterPreviewObserver.observe(document.body, { childList: true, subtree: true });
  }
})();
